import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductsService } from '../products.service';
import { NotificationService } from 'app/core/services/notification.service';
import { ConfigService } from 'app/core/services/config.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UtilService} from '../../../../../core/services/util.service';

declare var $: any;
@Component({
  selector: 'itpx-product-add',
  templateUrl: './product-add.component.html',
  styleUrls: ['./product-add.component.css']
})
export class ProductAddComponent implements OnInit {

    form: FormGroup;

    constructor(
        private service: ProductsService,
        private configService: ConfigService,
        private router: Router,
        private notificationService: NotificationService,
        private fb: FormBuilder,
        private utilService: UtilService
    ) { }

    ngOnInit() {
        this.buildForm();
    }
    buildForm() {
        this.form = this.fb.group({
            name: [null, Validators.required],
            hosted:[null],
            keywords: [[]],
            domains: [[]],
            categoryFamily: [[]],
            shortDescription: [null, Validators.required],
            quotation: [null],
            online: [null],
            available: [null],
            enriched: [null],
            editableCourseware: [null],
            brand:[null],
            'type.id': [null, Validators.required],
            'level.id': [null],
            'segment.id': [null],
            'group.id': [null, Validators.required]
        })
    }

    private onSaveFinished(data: any) {
        this.service.add(this.service.formatData(data))
        .subscribe(
            body => {
                const response = body['data'];
                this.notificationService.success('Successfully created the product', 'Success');
                this.router.navigate(['/agora/product-data/products/:id/edit', { id: response.id }]);
            },
            error => {}
        );
    }

    private onSubmit() {
        let form = this.form.value;

        let unflatten = this.utilService.unflatten(form);
        unflatten['pricing'] = this.utilService.unflatten(form.pricing);
        unflatten['courseInfo'] = this.utilService.unflatten(form.courseInfo);

        let request = this.service.formatData(unflatten);
        if(!request.segment || request.segment.id == 'null') {
            request.segment = null;
        }
        this.service.add(request)
            .subscribe(
                data => {
                    this.notificationService.success('Successfully added the product', 'Success');
                    this.router.navigate(['/agora/product-data/products/']);
                },
                error => {}
            )
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/products/add/product-add.component.ts